export default __webpack_public_path__ + "static/media/Gwent-YPMod1-InCourseWorkbook.b6b40661.pdf";